exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".login-card label.md-empty{\n    top: 20px;\n}\n\n.login-card label.md-focused{\n    top: 0;\n}\n.login-card label.md-checkbox-layout{\n  margin-top: 10px;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /home/runner/work/admin-portal-2/admin-portal-2/~/css-loader?{"sourceMap":false,"importLoaders":1}!/home/runner/work/admin-portal-2/admin-portal-2/~/postcss-loader?{"ident":"postcss"}!/home/runner/work/admin-portal-2/admin-portal-2/src/app/core/login.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/index.js?{"ident":"postcss"}!../../../../../src/app/core/login.css
// module chunks = 9